module.exports = __webpack_public_path__ + "img/huace9.f823c348.jpg";